<input ngx-google-places-autocomplete
       #placesRef="ngx-places"
       class="form-control-sm form-control"
       (onAddressChange)="handleAddressChange($event)" />
